import React, { useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Auth from "../screens/Auth/Auth";
import Home from "../screens/Home/Home";
import MatchDetails from "../screens/Matches/MatchDetails";
import OutletComponent from "../components/OutletComponent";
import PrivateRoute from "../screens/PrivateRoute";
import TournamentDashboard from "../screens/Tournaments/TournamentDashboard";
import TeamDetails from "../screens/Tournaments/TeamDetails";

const PageRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={"/auth"} />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/user" element={<PrivateRoute />}>
          {/* This is for common header */}
          <Route element={<OutletComponent />}>
            <Route path="home" element={<Home />} />
            <Route path="matchDetails" element={<MatchDetails />} />
            <Route
              path="tournamentDashboard"
              element={<TournamentDashboard />}
            />
            <Route path="teamDetails" element={<TeamDetails />} />
          </Route>
          {/* This is for common header */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default PageRoutes;
